import { lazy } from 'react';

export const LazyAccessorial = lazy(() => import('./accessorial').then((mod) => ({ default: mod.Accessorial })));
